import {
  FormFieldsByUniqueID,
  SimpleFormField,
} from 'components/form/formTypes'
import { GeckoToggleForm } from 'components/form/GeckoToggleForm'
import React from 'react'
import { SubmitHandler } from 'react-hook-form'
import { noOp } from 'utils/noOp'

interface GroupingInfoFormProps {
  formFields: FormFieldsByUniqueID[]
  inEditMode: boolean
  onSubmit: SubmitHandler<SimpleFormField>
}

export const GroupingInfoForm = React.forwardRef<
  HTMLFormElement,
  GroupingInfoFormProps
>(({ formFields, inEditMode, onSubmit }, ref) => {
  return (
    <GeckoToggleForm
      formFieldsByUniqueID={formFields}
      inEditMode={inEditMode}
      onSubmit={onSubmit}
      ref={ref}
      numberOfColumns={2}
      resetOnSubmit={true}
      pointAndClickApi={undefined}
      highlightCoordinate={noOp}
      displayCoordinateUpdates={noOp}
    />
  )
})

GroupingInfoForm.displayName = 'GroupingInfoForm'
